/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { SharingDataService } from "src/app/shared/service/sharing-data.service";
import { LoadingSpinnerService } from "src/app/shared/service/loading-spinner.service";
import { TranslationService } from "src/app/shared/service/translation.service";
import { DataServiceServiceProfile } from "../services/profile-data-service.service";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { AccessDeniedComponent } from "../access-denied/access-denied.component";
import { CommonModalComponent } from "src/app/shared/common-modal/common-modal.component";

@Component({
  selector: "app-alias-list",
  templateUrl: "./alias-list.component.html",
  styleUrls: ["./alias-list.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgxSkeletonLoaderModule, AccessDeniedComponent, CommonModalComponent]
})
export class AliasListComponent implements OnInit {

  @Input()
  isSwitchProfile: boolean = false;

  @ViewChild("showModalContent") showModalContent: TemplateRef<any> | undefined;
  private readonly SharingData = inject(SharingDataService);
  private readonly routes = inject(Router);
  private readonly dataService = inject(DataServiceServiceProfile);
  private readonly loadingSpinnerService = inject(LoadingSpinnerService);
  private readonly route = inject(ActivatedRoute);
  private readonly translationService = inject(TranslationService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);

  allSupportedLangCodes: any[] = this.translationService.getSupportedLanguageByCode();
  aliasRoute: any = this.route.snapshot.paramMap.get("profile");
  aliasClicked: boolean = false;
  alias: any;
  username: string = "";
  aliasList: any[] = [];
  groupList: any[] = [];
  isProfileSelected: boolean = false;
  profileNeedToSwitch: string = "";
  isSwitched: boolean = false;
  groupName: any;
  isProfileSwitched: boolean = false;
  payload: any;
  isCloseModal: boolean = false;
  showModal: boolean = true;
  component: string = "aliasComponent";
  isHeaderVisible: boolean = false;
  userEmail: string = '';
  noAccess: boolean = false;
  translationData: any;
  isPageAvailable = true;
  subscribe: any;
  type: string = 'small-popup';
  isProfileChanged: boolean = localStorage.getItem('isProfileSwitched') ? true : false
  noGroupsAvailable: boolean = false
  aliasIds: any[] = []
  profileSelectedIndex: any;
  profileData: any;
  userData: any

  ngOnInit(): any {
    if (!this.isSwitchProfile) {
      this.route.params
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe((params) => {
          this.isValidLanguage(params.languageId);
        });
    }


    if (localStorage.getItem("profile")) {
      this.SharingData.setAliasList(true);
    }
    this.fetchData();
  }

  public fetchData() {
    this.dataService
      .getAliasList()
      .subscribe({
        next: (response: any) => {
          const data = response['body']
          if (data) {
            this.userData = data
            this.username = data.displayName;
            this.userEmail = data.adminEmail
            localStorage.setItem('userName', this.username)
            localStorage.setItem('userEmail', this.userEmail)
            this.aliasList = data.profileInfo;
            this.aliasIds = data.profileIds
            this._cdr.markForCheck();
          }
        },
      });
  }

  isValidLanguage(languageId: string) {
    if (languageId && this.allSupportedLangCodes.includes(languageId)) {
      this.isPageAvailable = true;
    } else {
      this.routes.navigate(['404']);
    }
  }

  aliasSelected(i: any) {
    this.profileSelectedIndex = i
    if (this.isProfileChanged) {
      //payload while switching profile
      this.profileNeedToSwitch = this.aliasIds[i]
      this.isSwitched = true;
      this.payload = undefined;
    } else {
      //initial payload
      this.groupName = {
        groupName: this.aliasIds[i]
      };
      this.payload = this.groupName;
    }
    this.loadingSpinnerService.show()
    this.dataService
      .switchProfile(this.payload, this.isSwitched, this.profileNeedToSwitch)
      .subscribe({
        next: (data) => {
          this.showModal = false;
          this.alias = true;
          if (data) {
            this.isProfileChanged = true;
            localStorage.setItem("isProfileSwitched", "true");
            this.routes.navigate(["/events"]);
            localStorage.setItem("profile", this.alias);
            localStorage.setItem("aliasGroupName", this.aliasIds[i]);
            localStorage.setItem('profileName', this.aliasList[i]?.profileName);
            localStorage.setItem('profileImage', this.aliasList[i]?.profileImageUrl);
            this.isProfileSelected = true;
            this.SharingData.setAliasList(true);
            this.isProfileSwitched = true;
            this.SharingData.setProfileSelected(true);
            this.SharingData.setProfileChanged(true);
            this.toggleMobileMenu();
            this._cdr.markForCheck();
          }
        },
        error: (error) => {
          if (error.error["error-code"] == 1717) {
            this.callSwitchProfile();
          }
          this.loadingSpinnerService.hide();
          this._cdr.markForCheck();
        }
      });
  }

  callSwitchProfile() {
    this.profileNeedToSwitch = this.aliasIds[this.profileSelectedIndex];
    this.dataService.switchProfile(null, true, this.profileNeedToSwitch).subscribe(() => {
      localStorage.setItem('aliasGroupName', this.aliasIds[this.profileSelectedIndex]);
      localStorage.setItem('profileName', this.aliasList[this.profileSelectedIndex].profileName);
      localStorage.setItem('profileImage', this.aliasList[this.profileSelectedIndex].profileImageUrl);
      localStorage.setItem("profile", this.alias);
      this.routes.navigate(['events']);
      this._cdr.markForCheck();
    });
  }

  toggleMobileMenu() {
    this.SharingData.setMobileMenuStatus(false);
  }

}
